const skeletonClass = "animate-pulse rounded bg-[#E9ECF2]";

const PurchaseOptionsSkeleton: React.FC = () => {
  return (
    <div className="space-y-4 rounded-xl border border-[#E6E8ED] p-4">
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className="rounded-xl border border-[#E8EBF1] p-3">
          <div className={`${skeletonClass} h-4 w-1/3`} />
          <div className="mt-3 space-y-2">
            <div className={`${skeletonClass} h-4 w-3/4`} />
            <div className={`${skeletonClass} h-4 w-1/2`} />
          </div>
          <div className="mt-3 flex items-center justify-between">
            <div className={`${skeletonClass} h-5 w-20`} />
            <div className={`${skeletonClass} h-9 w-16 rounded-lg`} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default PurchaseOptionsSkeleton;
